import TopTabNavigationAdmin from "../navigation/TopTabNavigationAdmin";
const HRAdmin = ({ navigation }) => {
  return (
    <TopTabNavigationAdmin drawer='HRAdmin' />
  );
};

export default HRAdmin;